<template>
    <div>
        <template v-if="isAutoRegistering">
            <div class="loader-div" >
                <div class="loader-parent" >
                    <svg class="pl" viewBox="0 0 200 200" width="200" height="200" xmlns="http://www.w3.org/2000/svg">
                        <defs>
                            <linearGradient id="pl-grad1" x1="1" y1="0.5" x2="0" y2="0.5">
                                <stop offset="0%" stop-color="hsl(157, 100%, 66%)" />
                                <stop offset="100%" stop-color="hsl(210, 79%, 46%)" />
                            </linearGradient>
                            <linearGradient id="pl-grad2" x1="0" y1="0" x2="0" y2="1">
                                <stop offset="0%" stop-color="hsl(157, 100%, 66%)" />
                                <stop offset="100%" stop-color="hsl(210, 79%, 46%)" />
                            </linearGradient>
                        </defs>
                        <circle class="pl__ring" cx="100" cy="100" r="82" fill="none" stroke="url(#pl-grad1)" stroke-width="36" stroke-dasharray="0 257 1 257" stroke-dashoffset="0.01" stroke-linecap="round" transform="rotate(-90,100,100)" />
                        <line class="pl__ball" stroke="url(#pl-grad2)" x1="100" y1="18" x2="100.01" y2="182" stroke-width="36" stroke-dasharray="1 165" stroke-linecap="round" />
                    </svg>
                    <h2>{{ loaderMessage }}</h2>
                </div>
            </div>
        </template>

        <template v-else>
            <header>
                <div class="logo">{{ $t('screener.chatroom.button') }}</div>
                <p class="tagline">{{  $t('screener.chatroom.user.auto.register.subheading') }}</p>
            </header>
    
            <main>
                <PreviewTrailer
                    :url="beinChatFeatureInformationUrl"
                ></PreviewTrailer>
    
                <div class="action-section">
                    <div class="action-header">
                        <h2>{{ $t('screener.chatroom.user.auto.register.page.title') }}</h2>
                        <a href="javascript:void(0)" class="cta-button" @click="autoRegisterMember">{{ $t('screener.chatroom.user.auto.register.page.conitnue.btn.text') }}</a>
                    </div>
                    <div class="action-content">
                        <p>
                           {{ $t('screener.chatroom.user.auto.register.page.description') }}
                        </p>
                    </div>
                </div>
            </main>
        </template>
    </div>
</template>

<script>
import * as API from '@/api';
import DEFINES from "@/defines";
import PreviewTrailer from "@/components/screener/PreviewTrailer.vue";

export default {
    name : 'ChatRoomAutoRegister',
    components: {
        PreviewTrailer
    },
    async beforeRouteEnter(to, from, next) {
        await next(vm => {
            if(vm.$route.params){
                vm.doLoginWithAutoRegisterLinkLink(vm.$route.params);
            }
        });
    },
    data(){
        return {
            loaderMessage : this.$t('screener.chatroom.auto_register.existence_check_message'),
            isAutoRegistering: true,
            beinChatFeatureInformationUrl:DEFINES.BE_IN_INFO_VIDEO_URL
        }
    },
    methods: {
        async doLoginWithAutoRegisterLinkLink(payload){
            try {
                
                let response = await this.$store.dispatch("auth/loginWithAutoRegisterLink", payload);
                // console.log(response);
                
                await this.checkMemberExistence()

            } catch (error) {
                this.error_message = error.message;
            }finally{
                this.loading = false;
            }
        },
        async checkMemberExistence() {
            var response = await API.chatRoom.checkMemberExistenceBasedOnToken(this.$route.params);
            if (response.member.redirect_screener) {
                // Redirect user to the New page where he/she can have the 
                this.$router.push({name: 'screeners.chatroom.overview', params: {screener_id: response.member.screener_id}});
            }else{
                this.loaderMessage = null
                this.isAutoRegistering = false
            }
           
        },
        async autoRegisterMember(){
            this.loaderMessage = this.$t('screener.chatroom.auto_register.message')
            this.isAutoRegistering = true
            var response = await API.chatRoom.autoRegisterMember(this.$route.params);
            if (response.member.status) {
                this.loaderMessage = null
                this.isAutoRegistering = false
                // redirect user to screener
                this.$router.push({name: 'screeners.chatroom.overview', params: {screener_id: response.member.screener_id}});
            }
            
            
        }
    },
          
}
</script>

<style lang="scss" scoped>
.loader-div {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    flex-direction: column;
    text-align: center;
}
.loader-parent{
    display: flex;
    flex-direction: column;
    align-items: center;
}
.loader-parent h2 {
    margin-top: 3em;
}
.loader-content{
    text-align: center;
    margin-top: 5em;
}

.pl {
	display: block;
	width: 6.25em;
	height: 6.25em;
}
.pl__ring, .pl__ball {
	animation: ring 2s ease-out infinite;
}
.pl__ball {
	animation-name: ball;
}

/* Dark theme  */
@media (prefers-color-scheme: dark) {
	:root {
		--bg: hsl(var(--hue),10%,10%);
		--fg: hsl(var(--hue),10%,90%);
	}
}

/* Animation */
@keyframes ring {
	from {
		stroke-dasharray: 0 257 0 0 1 0 0 258;
	}
	25% {
		stroke-dasharray: 0 0 0 0 257 0 258 0;
	}
	50%, to {
		stroke-dasharray: 0 0 0 0 0 515 0 0;
	}
}
@keyframes ball {
	from, 50% {
		animation-timing-function: ease-in;
		stroke-dashoffset: 1;
	}
	64% {
		animation-timing-function: ease-in;
		stroke-dashoffset: -109;
	}
	78% {
		animation-timing-function: ease-in;
		stroke-dashoffset: -145;
	}
	92% {
		animation-timing-function: ease-in;
		stroke-dashoffset: -157;
	}
	57%, 71%, 85%, 99%, to {
		animation-timing-function: ease-out;
		stroke-dashoffset: -163;
	}
}
.top-header {
    position: fixed;
    top: 0;
    right: 0;
    padding: 1rem 2rem;
    display: flex;
    gap: 1rem;
    align-items: center;
    z-index: 100;
}

.top-header a {
    color: #00ff9d;
    text-decoration: none;
}

.language-selector {
    color: #00ff9d;
}

header {
    width: 100%;
    text-align: center;
    background: rgba(0, 0, 0, 0.3);
    margin-bottom: 2rem;
}

.logo {
    font-size: 2.5rem;
    font-weight: bold;
    margin-bottom: 1rem;
    background: linear-gradient(45deg, #00ff9d, #00cc7d);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.tagline {
    font-size: 1.2rem;
    color: #cccccc;
}

main {
    width: 90%;
    max-width: 1200px;
    text-align: center;
    margin:4rem;
}

.video-container {
    position: relative;
    width: 100%;
    max-width: 800px;
    margin: 2rem auto;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
}

.video-placeholder {
    width: 100%;
    padding-top: 56.25%;
    background: #111;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
}

.play-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 80px;
    height: 80px;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.play-icon::after {
    content: "";
    border-left: 30px solid #fff;
    border-top: 20px solid transparent;
    border-bottom: 20px solid transparent;
    margin-left: 8px;
}

.features {
    margin: 3rem 0;
    padding: 2rem;
    background: rgba(255, 255, 255, 0.05);
    border-radius: 12px;
}

.features h2 {
    margin-bottom: 1.5rem;
    font-size: 1.8rem;
    color: #00ff9d;
}

.features p {
    line-height: 1.6;
    color: #cccccc;
    margin-bottom: 1rem;
}

.cta-button {
    display: inline-block;
    padding: 1rem 2.5rem;
    font-size: 1.2rem;
    font-weight: bold;
    text-decoration: none;
    color: #ffffff;
    background-color: #E91E63;
    border-radius: 8px;
    transition: background-color 0.3s ease;
}

.cta-button:hover {
    background-color: #C2185B;
}

footer {
    margin-top: auto;
    width: 100%;
    padding: 1.5rem;
    text-align: center;
    background: rgba(0, 0, 0, 0.3);
    color: #888;
}

.action-section {
    width: 100%;
    margin: 1.5rem 0;
    padding: 1.5rem;
    background: rgba(255, 255, 255, 0.05);
    border-radius: 8px;
}

.action-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 2rem;
    margin-bottom: 1.5rem;
    padding-bottom: 1.5rem;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.action-header h2 {
    font-size: 1.4rem;
    color: #00ff9d;
    margin: 0;
    flex-grow: 1;
    text-align: left;
}

.cta-button {
    display: inline-block;
    padding: 0.75rem 2rem;
    font-size: 1rem;
    font-weight: 500;
    text-decoration: none;
    color: #ffffff;
    background-color: #E91E63;
    border-radius: 8px;
    transition: background-color 0.2s ease;
    white-space: nowrap;
}

.cta-button:hover {
    background-color: #C2185B;
}

.action-content p {
    line-height: 1.5;
    color: #cccccc;
    font-size: 0.95rem;
    margin-bottom: 0.75rem;
    text-align: left;;
}

.action-content p:last-child {
    margin-bottom: 0;
}

@media (max-width: 768px) {
    .logo {
        font-size: 2rem;
    }

    .tagline {
        font-size: 1rem;
    }

    .video-container {
        margin: 1rem auto;
    }

    .features {
        padding: 1.5rem;
    }

    .cta-button {
        padding: 0.8rem 2rem;
        font-size: 1rem;
    }
    .action-header {
        flex-direction: column;
        gap: 1rem;
        text-align: center;
    }

    .action-header h2 {
        text-align: center;
    }
    .action-content {
        text-align: center;
    }
}
</style>